import type { HelpArticle, HelpComment, PopularTopic } from "@/types/help";
import {
  MOCK_ARTICLES,
  MOCK_COMMENTS,
  MOCK_POPULAR_TOPICS,
} from "./help.mock";

// ---------------------------------------------------------------------------
// Help Center API client.
//
// First pass is frontend-only: every method resolves with mock data. When the
// yeschef-api help module lands, swap the bodies for `api.get(...)` calls — the
// method signatures and return types are already shaped for that.
// ---------------------------------------------------------------------------

const clone = <T>(value: T): T => structuredClone(value);

export const helpApi = {
  getArticles: (): Promise<HelpArticle[]> =>
    Promise.resolve(clone(MOCK_ARTICLES)),

  getArticle: (id: string): Promise<HelpArticle | undefined> =>
    Promise.resolve(clone(MOCK_ARTICLES.find((a) => a.id === id))),

  getPopularTopics: (): Promise<PopularTopic[]> =>
    Promise.resolve(clone(MOCK_POPULAR_TOPICS)),

  getComments: (articleId: string): Promise<HelpComment[]> => {
    // Unknown articles have no comments; known ones share the mock thread.
    const exists = MOCK_ARTICLES.some((a) => a.id === articleId);
    return Promise.resolve(exists ? clone(MOCK_COMMENTS) : []);
  },
};
